module.exports = __webpack_public_path__ + "static/img/yangxiaotian5.a01543e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/employeeStories/yangxiaotian5.png
// module id = 579g
// module chunks = 1